//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get';
import semver from 'semver';
import CallToAction from '@/components/elements/CallToAction.vue';
import SubscribeNewsletter from '@/components/elements/SubscribeNewsletter.vue';
import AppFaqs from '@/components/AppFaqs.vue';
import Card from '@/components/basics/Card';
import * as api from '@/services/api';

export default {
  components: { CallToAction, AppFaqs, Card },
  data() {
    return {
      loading: true,
      releases: {},
      tooltipUpdates: `Windows and macOS releases come with an <b>auto-updater</b>; you'll be
          notified when there's a new version and update the app if you decide
          so.<br /> \
          On Linux, if you install the app through Snap, you can manually update it
          through
          <code class="text-sm text-nowrap">sudo snap refresh bomist</code>`
    };
  },
  computed: {
    mostRecentRelease() {
      if (Object.keys(this.releases) === 0) return '';

      return Object.values(this.releases)
        .filter(Boolean)
        .sort((a, b) => (semver.gt(a.version, b.version) ? -1 : 1))[0];
    }
  },
  async mounted() {
    try {
      const response = await api.releasesV2();
      this.releases = response.data;
    } catch (err) {
      this.$sentry.captureException(err);
      this.releases = {
        windows: {},
        linux: {},
        mac: {}
      };
    } finally {
      this.loading = false;
    }
  },
  methods: {
    onDownload() {
      this.$toast.info('Downloading... It might take a few seconds.', {
        duration: 10000,
        position: 'bottom-center'
      });

      this.$gtag.event('conversion', {
        send_to: 'AW-10851538947/dXGdCPS588sDEIOwtbYo'
      });
      // this.$twitterAds('tw-oj0ru-oj0rz');
      // window.lintrk('track', { conversion_id: 8599450 });
    }
  },
  head() {
    return {
      title: 'BOMIST: Downloads',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Available on Windows, macOS and Linux.'
        }
      ]
    };
  }
};
